export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

export type PasswordRequirement = {
  key: "length" | "match";
  label: string;
  met: boolean;
};

export function passwordRequirements(password: string, confirmation: string): PasswordRequirement[] {
  return [
    {
      key: "length",
      label: `At least ${PASSWORD_MIN_LENGTH} characters`,
      met: password.length >= PASSWORD_MIN_LENGTH && password.length <= PASSWORD_MAX_LENGTH,
    },
    {
      key: "match",
      label: "Both passwords match",
      met: confirmation.length > 0 && password === confirmation,
    },
  ];
}

export function validatePasswordResetInput(password: string, confirmation: string): string | null {
  if (password.length < PASSWORD_MIN_LENGTH) {
    return `Use at least ${PASSWORD_MIN_LENGTH} characters for your new password.`;
  }
  if (password.length > PASSWORD_MAX_LENGTH) {
    return `Use no more than ${PASSWORD_MAX_LENGTH} characters for your new password.`;
  }
  if (password !== confirmation) {
    return "The passwords do not match yet.";
  }
  return null;
}
